/** Lowercase `step` values — used for i18n keys and the `step` filter arg. */
export const LOG_STEPS = [
  'matched',
  'status_change',
  'download_video',
  'download_transcript',
  'download_chat',
  'download_audio',
  'ai_started',
  'ai_waiting',
  'ai_completed',
  'published',
  'error',
] as const;

/** Lowercase `level` values — used for i18n keys and the `level` filter arg. */
export const LOG_LEVELS = ['info', 'warning', 'error'] as const;

/** Enum value (`DOWNLOAD_VIDEO`) → lowercase key (`download_video`). */
export const logKey = (value: string): string => String(value).toLowerCase();

/** Timeline dot colour for a processing-log level. */
export const levelColor = (level: string): string => {
  switch (logKey(level)) {
    case 'error':
      return '#ef4444';
    case 'warning':
      return '#f59e0b';
    default:
      return '#2563eb';
  }
};

/**
 * `ZoomProcessingLogType.details` is a `JSONString` scalar — defensively
 * coerce it to a plain object whether it arrives parsed or as a string.
 */
export const parseDetails = (details: unknown): Record<string, unknown> => {
  if (!details) {
    return {};
  }
  if (typeof details === 'string') {
    try {
      const parsed = JSON.parse(details);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
      return {};
    }
  }
  return typeof details === 'object'
    ? (details as Record<string, unknown>)
    : {};
};
